import { NodeTree, ROOT_NODE } from "@craftjs/core";
import type { CraftQuery } from "src/types";

export default function getTopLevelNodeTrees(query: CraftQuery): NodeTree[] {
  return (
    query
      .node(ROOT_NODE)
      ?.getChildNodes()
      .map((nodeQuery) => nodeQuery.toNodeTree()) ?? []
  );
}
